/**
 * GorevAtamaView store köprüsü (micro-7-7; micro-8-2 Pinia-only).
 */
import { useScenarioStore } from "@/stores";

export function getActiveScenarioId() {
  return useScenarioStore().aktifSenaryoId ?? null;
}
